<div class="modal">
  <!-- @if (tournament.tournamentUserStatus$ | async; as status) {
    <div class="modal__content">
      <div class="window" [style.padding]="status?.award_place ? '60px 10px 100px' : '60px 10px'">
        <div class="title">{{'t.leaders' | translate}}</div>
        <i class="window__close icon-close" (click)="modal.close()"></i>
        <app-tournament-leaders
        class="leaderboard"
        [tournament]="tournament"
        [countLeaders]="50"
        [hideBtn]="true"
        [hideTitle]="true"
        >
      </app-tournament-leaders>
    </div>
  </div>
  @if (status?.award_place) {
    <div class="current-place">
      <div class="current-place__position text-gradient">{{status?.award_place}}</div>
      <div class="current-place__title text-gradient">{{'t.your-place' | translate}}</div>
      <div class="current-place__score">{{status?.bets}}</div>
    </div>
  }
} -->
</div>
